import Model from '@/store/plugins/orm/Model';
import { Product, Order, TaxRate, Client } from './ModelRepository';

import HashGen from '@/utilities/HashGen';
import Money from '@/wrappers/Money';
import i18n from '@/i18n';

export class OrderItem extends Model {
    static get entity() {
        return 'order_items';
    }

    static get primaryKey() {
        return 'hash';
    }

    static getExemptFromTaxCode(key) {
        if(locale === 'sr') {
            const reason = this.exemptFromTaxReasons.find(r => key && r.key === key)
            return reason?.code || null;
        }

        return key === 'disabled' ? 'taxes_disabled' : null
    }

    static get exemptFromTaxReasons() {
        const reasonLabel = (reason) => {
            const reasonText = i18n.t(`order.exempt_from_tax_reason.${reason.code}`);
            if(locale !== 'sr') return reasonText;

            const category = reason.category ? `(${reason.category}) ` : '';
            return category + reason.code + ': ' + reasonText;
        }

        let reasons = [];
        if(locale === 'me') {
            reasons = [
                { code: 'VAT_CL17', category: null },
                { code: 'VAT_CL20', category: null },
                { code: 'VAT_CL26', category: null },
                { code: 'VAT_CL27', category: null },
                { code: 'VAT_CL28', category: null },
                { code: 'VAT_CL29', category: null },
                { code: 'VAT_CL30', category: null },
                { code: 'VAT_CL44', category: null },
            ]
        } else if(locale === 'sr') {
            reasons = [
                { code: 'PDV-RS-OBJ', category: 'S20' },
                { code: 'PDV-RS-OBJ', category: 'S10' },
                { code: 'PDV-RS-10-2-1', category: 'AE20' },
                { code: 'PDV-RS-10-2-2', category: 'AE20' },
                { code: 'PDV-RS-10-2-3', category: 'AE20' },
                { code: 'PDV-RS-10-2-4', category: 'AE20' },
                { code: 'PDV-RS-10-2-5-1', category: 'AE20' },
                { code: 'PDV-RS-10-2-5-2', category: 'AE20' },
                { code: 'PDV-RS-10-2-5-3', category: 'AE20' },
                { code: 'PDV-RS-10-2-5-3-OBJ', category: 'AE20' },
                { code: 'PDV-RS-36b-6', category: 'AE20' },
                { code: 'PDV-RS-10-2-1', category: 'AE10' },
                { code: 'PDV-RS-10-2-2', category: 'AE10' },
                { code: 'PDV-RS-10-2-3', category: 'AE10' },
                { code: 'PDV-RS-10-2-4', category: 'AE10' },
                { code: 'PDV-RS-10-2-5-1', category: 'AE10' },
                { code: 'PDV-RS-10-2-5-2', category: 'AE10' },
                { code: 'PDV-RS-10-2-5-3', category: 'AE10' },
                { code: 'PDV-RS-10-2-5-3-OBJ', category: 'AE10' },
                { code: 'PDV-RS-11-1-1', category: 'O' },
                { code: 'PDV-RS-11-1-2', category: 'O' },
                { code: 'PDV-RS-11-1-3', category: 'O' },
                { code: 'PDV-RS-11-1-4', category: 'O' },
                { code: 'PDV-RS-11-1-5', category: 'O' },
                { code: 'PDV-RS-11-3', category: 'O' },
                { code: 'PDV-RS-12-4', category: 'O' },
                { code: 'PDV-RS-12-6-1', category: 'O' },
                { code: 'PDV-RS-12-6-2', category: 'O' },
                { code: 'PDV-RS-12-6-3', category: 'O' },
                { code: 'PDV-RS-12-6-4-1', category: 'O' },
                { code: 'PDV-RS-12-6-4-2', category: 'O' },
                { code: 'PDV-RS-12-6-4-3', category: 'O' },
                { code: 'PDV-RS-12-6-4-4', category: 'O' },
                { code: 'PDV-RS-12-6-4-5', category: 'O' },
                { code: 'PDV-RS-12-6-5', category: 'O' },
                { code: 'PDV-RS-12-6-6', category: 'O' },
                { code: 'PDV-RS-12-6-7-1', category: 'O' },
                { code: 'PDV-RS-12-6-7-2', category: 'O' },
                { code: 'PDV-RS-12-6-7-3', category: 'O' },
                { code: 'PDV-RS-12-6-7-4', category: 'O' },
                { code: 'PDV-RS-12-6-7-5', category: 'O' },
                { code: 'PDV-RS-12-6-7-6', category: 'O' },
                { code: 'PDV-RS-12-6-7-7', category: 'O' },
                { code: 'PDV-RS-12-6-7-8', category: 'O' },
                { code: 'PDV-RS-12-6-7-9', category: 'O' },
                { code: 'PDV-RS-12-6-7-10', category: 'O' },
                { code: 'PDV-RS-12-6-7-11', category: 'O' },
                { code: 'PDV-RS-12-6-7-12', category: 'O' },
                { code: 'PDV-RS-12-6-8', category: 'O' },
                { code: 'PDV-RS-12-9', category: 'O' },
                { code: 'PDV-RS-61', category: 'O' },
                { code: 'PDV-RS-25-1-1', category: 'E' },
                { code: 'PDV-RS-25-1-1a', category: 'E' },
                { code: 'PDV-RS-25-1-2', category: 'E' },
                { code: 'PDV-RS-25-1-3', category: 'E' },
                { code: 'PDV-RS-25-1-4', category: 'E' },
                { code: 'PDV-RS-25-1-5', category: 'E' },
                { code: 'PDV-RS-25-1-6', category: 'E' },
                { code: 'PDV-RS-25-1-7', category: 'E' },
                { code: 'PDV-RS-25-1-8', category: 'E' },
                { code: 'PDV-RS-25-2-1', category: 'E' },
                { code: 'PDV-RS-25-2-2', category: 'E' },
                { code: 'PDV-RS-25-2-3', category: 'E' },
                { code: 'PDV-RS-25-2-3a', category: 'E' },
                { code: 'PDV-RS-25-2-3b', category: 'E' },
                { code: 'PDV-RS-25-2-5', category: 'E' },
                { code: 'PDV-RS-25-2-6', category: 'E' },
                { code: 'PDV-RS-25-2-7', category: 'E' },
                { code: 'PDV-RS-25-2-8', category: 'E' },
                { code: 'PDV-RS-25-2-9', category: 'E' },
                { code: 'PDV-RS-25-2-10', category: 'E' },
                { code: 'PDV-RS-25-2-11', category: 'E' },
                { code: 'PDV-RS-25-2-12', category: 'E' },
                { code: 'PDV-RS-25-2-13', category: 'E' },
                { code: 'PDV-RS-25-2-14', category: 'E' },
                { code: 'PDV-RS-25-2-15', category: 'E' },
                { code: 'PDV-RS-25-2-16', category: 'E' },
                { code: 'PDV-RS-25-2-17', category: 'E' },
                { code: 'PDV-RS-25-2-18', category: 'E' },
                { code: 'PDV-RS-25-2-19', category: 'E' },
                { code: 'PDV-RS-6-1-1', category: 'R' },
                { code: 'PDV-RS-6a', category: 'R' },
                { code: 'PDV-RS-6-ostalo', category: 'R' },
                { code: 'PDV-RS-24-1-1', category: 'Z' },
                { code: 'PDV-RS-24-1-2', category: 'Z', key: 'export' },
                { code: 'PDV-RS-24-1-3', category: 'Z' },
                { code: 'PDV-RS-24-1-5', category: 'Z' },
                { code: 'PDV-RS-24-1-5a', category: 'Z' },
                { code: 'PDV-RS-24-1-6', category: 'Z' },
                { code: 'PDV-RS-24-1-6a', category: 'Z' },
                { code: 'PDV-RS-24-1-7', category: 'Z' },
                { code: 'PDV-RS-24-1-7a', category: 'Z' },
                { code: 'PDV-RS-24-1-8', category: 'Z' },
                { code: 'PDV-RS-24-1-9', category: 'Z' },
                { code: 'PDV-RS-24-1-10', category: 'Z' },
                { code: 'PDV-RS-24-1-11', category: 'Z' },
                { code: 'PDV-RS-24-1-12', category: 'Z' },
                { code: 'PDV-RS-24-1-13', category: 'Z' },
                { code: 'PDV-RS-24-1-14', category: 'Z' },
                { code: 'PDV-RS-24-1-15', category: 'Z' },
                { code: 'PDV-RS-24-1-16-1', category: 'Z', key: 'diplomat' },
                { code: 'PDV-RS-24-1-16-2', category: 'Z' },
                { code: 'PDV-RS-24-1-16-3', category: 'Z' },
                { code: 'PDV-RS-24-1-16-4', category: 'Z' },
                { code: 'PDV-RS-24-1-16a', category: 'Z' },
                { code: 'PDV-RS-24-1-16b', category: 'Z' },
                { code: 'PDV-RS-24-1-16v', category: 'Z' },
                { code: 'PDV-RS-24-1-16g', category: 'Z' },
                { code: 'PDV-RS-24-1-17', category: 'Z' },
                { code: 'PDV-RS-33', category: 'SS', key: 'disabled' },
                { code: 'PDV-RS-35-7', category: 'SS' },
                { code: 'PDV-RS-36-5', category: 'SS' },
                { code: 'PDV-RS-36b-4', category: 'SS' },
                { code: 'PDV-RS-7a-4', category: 'OE' },
                { code: 'PDV-RS-9', category: 'OE' },
                { code: 'PDV-RS-17-4-2', category: 'OE' },
                { code: 'PDV-RS-17-4-3', category: 'OE' },
                { code: 'PDV-RS-4-4-2NP', category: 'OE' },
                { code: 'PDV-RS-5-4-2NP', category: 'OE' },
                { code: 'PDV-RS-3NP-ostalo', category: 'OE' },
                { code: 'PDV-RS-4', category: 'N' },
                { code: 'PDV-RS-5', category: 'N' },
                { code: 'PDV-RS-6-1-1 (BN)', category: 'N' },
                { code: 'PDV-RS-3-DZ', category: 'N' },
            ]
        } else {
            reasons = [{ code: 'VAT_EXCL', category: null }]
        }

        return reasons.map(r => {
            r.label = reasonLabel(r)
            return r
        })
    }

    static fields() {
        return {
            id: this.attr(null),
            hash: this.attr(HashGen.regular()),
            name: this.attr(null),
            gtin: this.attr(null),
            unit_of_measure: this.attr(null),
            discount_percent: this.attr('0.00', value => _.round(value, 2).toFixed(2)),
            additional_discount_percent: this.attr('0.00', value => _.round(value, 2).toFixed(2)),
            unit_price: this.attr('0.0000', value => _.round(value, 4).toFixed(4)),
            tax_rate_id: this.attr(null),
            tax_rate: this.attr('0.00', value => _.round(value, 2).toFixed(2)),
            order_id: this.attr(null),
            order_hash: this.attr(null),
            ref_order_hash: this.attr(null),
            ref_order_item_hash: this.attr(null),
            product_id: this.attr(null),
            count: this.attr('1.000', value => _.round(value, 3).toFixed(3)),
            additional_count: this.attr('0.000', value => _.round(value, 3).toFixed(3)),
            comments: this.attr([], value => value || []),
            custom_price: this.attr(false, value => !!value),
            exempt_from_tax: this.attr(null),
            reverse_calculation: this.attr(false, value => !!value),

            product: this.belongsTo(Product, 'product_id'),
            order: this.belongsTo(Order, 'order_hash')
        };
    }

    /**
     * Make a copy of the item.
     */
    $duplicate() {
        return new OrderItem(this.$toJson());
    }

    /**
     * Make a fresh copy of the item and link it to the specified order
     */
    fresh(order, reverse = false) {
        const freshItem = this.$duplicate();
        freshItem.id = null;
        freshItem.hash = HashGen.regular();
        freshItem.order_id = null;
        freshItem.order_hash = order.hash;

        if(reverse) {
            freshItem.count = _.round(-1 * freshItem.getCount(), 3).toFixed(3);
        }

        return freshItem;
    }

    /**
     * Get Resulting Item (item with additional count and discount)
     */
    getResultingItem() {
        const resultingItem = this.$duplicate();

        resultingItem.count = this.getCount() + this.getAdditionalCount();
        resultingItem.additional_count = '0.000';

        const resultingDiscountPercent =
            (1 - (1 - this.getDiscountPercent() / 100) * (1 - this.getAdditionalDiscountPercent() / 100)) * 100;
        resultingItem.discount_percent = resultingDiscountPercent.toFixed(6);
        resultingItem.additional_discount_percent = '0.00';

        return resultingItem;
    }

    /**
     * Give item discount.
     */
    giveDiscount(percent) {
        if (percent < 0 || percent > 99) return;
        this.discount_percent = _.round(percent, 2).toFixed(2);
    }

    /**
     * Give additional item discount. Resets additional count
     */
    giveAdditionalDiscount(percent) {
        if (percent < 0 || percent > 99) return;

        if (percent != 0) {
            this.additional_count = '0.000';
        }

        this.additional_discount_percent = _.round(percent, 2).toFixed(2);
    }

    /**
     * Update item count.
     */
    updateCount(count) {
        if (count == 0) return;
        this.count = _.round(count, 3).toFixed(3);
    }

    /**
     * Update additional item count. Resets additional item discount
     */
    updateAdditionalCount(count) {
        if (count != 0) {
            this.additional_discount_percent = '0.00';
        }

        this.additional_count = _.round(count, 3).toFixed(3);
    }

    /**
     * Update item price.
     */
    updateUnitPrice(price) {
        if (price <= 0) return;
        this.custom_price = true;
        this.unit_price = Money.parse(price).toFormat('0.0000');
    }

    /**
     * Set item comments.
     */
    setComments(comments) {
        this.comments = comments;
    }

    /**
     * Set item exempt from tax.
     */
    setExemptFromTax(exemptFromTaxReason) {
        const product = this.getProduct();
        if (!product) return;

        this.exempt_from_tax = exemptFromTaxReason;

        if (exemptFromTaxReason) {
            this.unit_price = this.getUnitPriceBeforeTax().toFormat('0.0000');
            this.tax_rate = 0;

            if(locale !== 'me') {
                const taxRate = exemptFromTaxReason === OrderItem.getExemptFromTaxCode('disabled')
                    ? TaxRate.getTaxesDisabledTaxRate()
                    : TaxRate.getZeroTaxRate();

                if (taxRate) {
                    this.tax_rate_id = taxRate.id;
                }
            }
        } else {
            const unitPriceBeforeTax = this.getUnitPriceBeforeTax();
            let taxRate = locale !== 'me' ? product.getTaxRate() : TaxRate.find(this.tax_rate_id);
            const taxesEnabled = this.$store().getters.tenant.venue.taxes_enabled;

            if(!taxesEnabled && locale === 'sr') {
                taxRate = TaxRate.getTaxesDisabledTaxRate()
            }

            if(!taxesEnabled) {
                this.setForcedExemptFromTax('disabled');
            }

            this.tax_rate = this.exempt_from_tax ? 0 : taxRate.rate;

            this.unit_price = this.reverse_calculation
                ? unitPriceBeforeTax.toFormat('0.0000')
                : unitPriceBeforeTax.multiply(1 + this.getTaxRate() / 100).toFormat('0.0000');

            if (locale !== 'me' && taxRate) {
                this.tax_rate_id = taxRate.id;
            }
        }
    }

    /**
     * Get forced exempt from tax
     */
    setForcedExemptFromTax(reason) {
        const newExemptFromTax = OrderItem.getExemptFromTaxCode(reason);
        if(newExemptFromTax) {
            this.exempt_from_tax = newExemptFromTax;
        }
    }

    /**
     * Check if item has a manually set exempt from task
     */
    hasManuallySetExemptFromTax() {
        return this.exempt_from_tax
            && this.exempt_from_tax !== OrderItem.getExemptFromTaxCode('disabled')
            && this.exempt_from_tax !== OrderItem.getExemptFromTaxCode('export')
            && this.exempt_from_tax !== OrderItem.getExemptFromTaxCode('diplomat')
    }

    /**
     * Set Zero Tax
     */
    setZeroTax(reason) {
        if (!this.product_id) return;

        this.unit_price = this.getUnitPriceBeforeTax().toFormat('0.0000');

        this.setForcedExemptFromTax(reason);

        const taxRate = TaxRate.getZeroTaxRate();
        this.tax_rate_id = taxRate ? taxRate.id : null;
        this.tax_rate = 0;
    }

    /**
     * Set Original Tax
     */
    setOriginalItemsTax() {
        const product = this.getProduct();
        if (!product) return;

        const unitPriceBeforeTax = this.getUnitPriceBeforeTax();
        let taxRate = product.getTaxRate();
        const taxesEnabled = this.$store().getters.tenant.venue.taxes_enabled;

        if(!taxesEnabled && locale === 'sr') {
            taxRate = TaxRate.getTaxesDisabledTaxRate();
        }

        if(!this.hasManuallySetExemptFromTax()) {
            if(!taxesEnabled) {
                this.setForcedExemptFromTax('disabled');
            } else {
                this.exempt_from_tax = null;
            }
        }

        this.tax_rate_id = taxRate ? taxRate.id : null;
        this.tax_rate = !this.exempt_from_tax && taxRate ? taxRate.rate : 0;

        this.unit_price = this.reverse_calculation
            ? unitPriceBeforeTax.toFormat('0.0000')
            : unitPriceBeforeTax.multiply(1 + this.getTaxRate() / 100).toFormat('0.0000');
    }

    static createForOrder(order, refOrder) {
        const reverseCalculation = !!this.store().getters.tenant.venue.settings.reverse_calculation;

        return new OrderItem({
            hash: HashGen.regular(),
            name: refOrder.getIic(),
            gtin: null,
            unit_of_measure: null,
            order_id: order.id,
            order_hash: order.hash,
            unit_price: refOrder.getToPay().toFormat('0.0000'),
            tax_rate_id: null,
            tax_rate: 0,
            product_id: null,
            ref_order_hash: refOrder.hash,
            ref_order_item_hash: null,
            count: 1,
            exempt_from_tax: null,
            reverse_calculation: reverseCalculation
        });
    }

    setPricelist(order, pricelist = 0) {
        const client = order.client_id ? Client.find(order.client_id) : null;
        const zeroTaxMode = order.export || client?.isDiplomat();
        const product = this.getProduct();

        this.unit_price = zeroTaxMode
            ? product.getPriceBeforeTax(pricelist).toFormat('0.0000')
            : product.getSellingPrice(pricelist).toFormat('0.0000')
    }

    static createForProduct(order, product, count) {
        const client = order.client_id ? Client.find(order.client_id) : null;
        const zeroTaxMode = order.export || client?.isDiplomat();

        const taxesEnabled = this.store().getters.tenant.venue.taxes_enabled;
        const reverseCalculation = !!this.store().getters.tenant.venue.settings.reverse_calculation;

        const pricelistId = this.store().getters.activePricelist;

        let taxRate = product.getTaxRate();
        let exemptFromTax = null;
        if(zeroTaxMode) {
            taxRate = TaxRate.getZeroTaxRate();
            exemptFromTax = OrderItem.getExemptFromTaxCode(client?.isDiplomat() ? 'diplomat' : 'export');
        } else if(!taxesEnabled) {
            if(locale === 'sr') {
                taxRate = TaxRate.getTaxesDisabledTaxRate();
            }

            exemptFromTax = OrderItem.getExemptFromTaxCode('disabled');
        }

        return new OrderItem({
            hash: HashGen.regular(),
            name: product.name,
            gtin: product.gtin,
            unit_of_measure: product.unit_of_measure_sold,
            discount_percent: client ? client.discount_percent : '0.00',
            order_id: order.id,
            order_hash: order.hash,
            unit_price: zeroTaxMode
                ? product.getPriceBeforeTax(pricelistId).toFormat('0.0000')
                : product.getSellingPrice(pricelistId).toFormat('0.0000'),
            tax_rate_id: taxRate ? taxRate.id : null,
            tax_rate: exemptFromTax || !taxRate ? 0 : taxRate.rate,
            product_id: product.id,
            ref_order_hash: null,
            ref_order_item_hash: null,
            count: count,
            exempt_from_tax: exemptFromTax,
            reverse_calculation: reverseCalculation
        });
    }

    static createForTaxItem(order, taxItem) {
        const reverseCalculation = !!this.store().getters.tenant.venue.settings.reverse_calculation;
        const priceBeforeTax = Money.parse(taxItem.price_before_tax)
        const value = Money.parse(taxItem.value)

        return new OrderItem({
            hash: HashGen.regular(),
            name: taxItem.name ? `${taxItem.name} (${taxItem.label})` : taxItem.label,
            gtin: null,
            unit_of_measure: 'pcs',
            order_id: order.id,
            order_hash: order.hash,
            unit_price: reverseCalculation ? priceBeforeTax.toFormat('0.0000') : priceBeforeTax.add(value).toFormat('0.0000'),
            tax_rate_id: taxItem.id,
            tax_rate: taxItem.rate,
            product_id: null,
            ref_order_hash: null,
            ref_order_item_hash: null,
            count: 1,
            exempt_from_tax: null,
            reverse_calculation: reverseCalculation
        });
    }

    static createForAdvanceItem(order, taxItem, paidAdvance) {
        const reverseCalculation = !!this.store().getters.tenant.venue.settings.reverse_calculation;
        const priceAfterTax = Money.parse(paidAdvance);
        const priceBeforeTax = Money.parse(Money.parse(paidAdvance).divide(1 + taxItem.rate / 100).toFormat('0.0000'));

        return new OrderItem({
            hash: HashGen.regular(),
            name: i18n.t('general.advance') + ' ' + taxItem.label,
            gtin: null,
            unit_of_measure: null,
            order_id: order.id,
            order_hash: order.hash,
            unit_price: reverseCalculation ? priceBeforeTax.toFormat('0.0000') : priceAfterTax.toFormat('0.0000'),
            tax_rate_id: taxItem.id,
            tax_rate: taxItem.rate,
            product_id: null,
            ref_order_hash: null,
            ref_order_item_hash: null,
            count: -1,
            exempt_from_tax: null,
            reverse_calculation: reverseCalculation
        });
    }

    /**
     * Lazy Get Product
     */
    getProduct() {
        const product = Product.all().find(product => product.id === this.product_id);

        if (product) {
            const taxRate = TaxRate.all().find(taxRate => taxRate.id === product.tax_rate_id);
            product.tax_rate = taxRate;
        }

        return product;
    }

    /**
     * Check if this order item is the same as another item (can be merged with it)
     */
    canMergeWith(item) {
        return this.name === item.name
            && this.gtin === item.gtin
            && this.unit_of_measure === item.unit_of_measure
            && this.discount_percent === item.discount_percent
            && this.additional_discount_percent === item.additional_discount_percent
            && this.unit_price === item.unit_price
            && this.tax_rate_id === item.tax_rate_id
            && this.tax_rate === item.tax_rate
            && this.product_id === item.product_id
            && this.exempt_from_tax === item.exempt_from_tax
            && this.reverse_calculation === item.reverse_calculation;
    }

    /**
     * Merge order items
     */
    static merge(items, order) {
        const mergedItems = [];

        items.forEach(item => {
            const freshItem = item.fresh(order);
            const addedItem = mergedItems.find(i => i.canMergeWith(freshItem))
            if(addedItem) {
                addedItem.count = _.round(addedItem.getCount() + freshItem.getCount(), 3).toFixed(3);
            } else {
                mergedItems.push(freshItem);
            }
        })

        return mergedItems;
    }

    getDiscountPercent() {
        return parseFloat(this.discount_percent);
    }

    getAdditionalDiscountPercent() {
        return parseFloat(this.additional_discount_percent);
    }

    getTaxRate() {
        return parseFloat(this.tax_rate);
    }

    getTaxRateLabel() {
        const taxRate = TaxRate.find(this.tax_rate_id);
        return taxRate ? taxRate.label : '';
    }

    getCount() {
        return parseFloat(this.count);
    }

    getAdditionalCount() {
        return parseFloat(this.additional_count);
    }

    /**
     * Get unit price before discount
     */
    getUnitPrice() {
        return Money.parse(this.unit_price);
    }

    /**
     * Get price before discount
     */
    getPrice() {
        const format = locale === 'sr' || locale === 'ba' ? '0.00' : '0.0000';

        if (this.reverse_calculation) {
            const value = this.getUnitPriceBeforeTax()
                .multiply(this.getCount())
                .multiply(1 + this.getTaxRate() / 100);

            return Money.parse(value.toFormat(format));
        }

        const value = this.getUnitPriceAfterTax().multiply(this.getCount());

        return Money.parse(value.toFormat(format));
    }

    /**
     * Get the unit price (product price after tax and discount) - UPA
     */
    getUnitPriceAfterDiscount() {
        if (this.reverse_calculation) {
            const value = this.getUnitPriceBeforeTax()
                .multiply(1 + this.getTaxRate() / 100)
                .multiply(1 - this.getDiscountPercent() / 100);

            return Money.parse(value.toFormat('0.0000'));
        }

        const value = this.getUnitPriceAfterTax().multiply(1 - this.getDiscountPercent() / 100);

        return Money.parse(value.toFormat('0.0000'));
    }

    /**
     * Get the unit price with discount before tax
     */
    getUnitPriceAfterDiscountBeforeTax() {
        if (this.reverse_calculation) {
            const value = this.getUnitPriceBeforeTax()
                .multiply(1 - this.getDiscountPercent() / 100);

            return Money.parse(value.toFormat('0.0000'));
        }

        const value = this.getUnitPriceAfterTax()
            .multiply(1 - this.getDiscountPercent() / 100)
            .divide(1 + this.getTaxRate() / 100)

        return Money.parse(value.toFormat('0.0000'));
    }

    /**
     * Get the unit price before tax - UPB
     */
    getUnitPriceBeforeTax() {
        if (this.reverse_calculation) {
            const value = this.getUnitPrice();
            return Money.parse(value.toFormat('0.0000'));
        }

        const value = this.getUnitPrice()
            .divide(1 + this.getTaxRate() / 100)

        return Money.parse(value.toFormat('0.0000'));
    }

    /**
     * Get the unit price after tax before discount
     */
    getUnitPriceAfterTax() {
        if (this.reverse_calculation) {
            const value = this.getUnitPrice().multiply(1 + this.getTaxRate() / 100);
            return Money.parse(value.toFormat('0.0000'));
        }

        const value = this.getUnitPrice();
        return Money.parse(value.toFormat('0.0000'));
    }

    /**
     * Get the to pay amount for order item - PA
     */
    getToPay() {
        const format = locale === 'sr' || locale === 'ba' ? '0.00' : '0.0000';

        if (this.reverse_calculation) {
            const value = this.getPriceBeforeTax().add(this.getTax());
            return Money.parse(value.toFormat(format));
        }

        const value = this.getUnitPriceAfterDiscount().multiply(this.getCount());
        return Money.parse(value.toFormat(format));
    }

    /**
     * Get the tax amount - VA
     */
    getTax() {
        if (this.reverse_calculation) {
            const value = this.getPriceBeforeTax().multiply(this.getTaxRate() / 100);
            return Money.parse(value.toFormat('0.0000'));
        }

        const value = this.getToPay().multiply(1 - 1 / (1 + this.getTaxRate() / 100));
        return Money.parse(value.toFormat('0.0000'));
    }

    /**
     * Get the price before tax - PB
     */
    getPriceBeforeTax() {
        if (this.reverse_calculation) {
            if(locale === 'sr') {
                const value = this.getUnitPriceAfterDiscountBeforeTax()
                    .multiply(this.getCount());

                return Money.parse(value.toFormat('0.0000'));
            }

            const value = this.getUnitPriceBeforeTax()
                .multiply(1 - this.getDiscountPercent() / 100)
                .multiply(this.getCount());

            return Money.parse(value.toFormat('0.0000'));
        }

        const value = this.getToPay().subtract(this.getTax());
        return Money.parse(value.toFormat('0.0000'));
    }

    /**
     * Get the discount amount
     */
    getDiscountAmount() {
        const format = locale === 'sr' || locale === 'ba' ? '0.00' : '0.0000';
        const value = this.getPrice().subtract(this.getToPay());
        return Money.parse(value.toFormat(format));
    }

    /**
     * Get additional to pay amount for order item
     */
    getAdditionalToPay() {
        return this.getAdditionalDiscountPercent() != 0 || this.getAdditionalCount() != 0
            ? this.getResultingItem()
                  .getToPay()
                  .subtract(this.getToPay())
            : Money.parse(0);
    }

    /**
     * Get additional tax amount
     */
    getAdditionalTax() {
        return this.getAdditionalDiscountPercent() != 0 || this.getAdditionalCount() != 0
            ? this.getResultingItem()
                  .getTax()
                  .subtract(this.getTax())
            : Money.parse(0);
    }

    /**
     * Get additional price before tax
     */
    getAdditionalPriceBeforeTax() {
        return this.getAdditionalDiscountPercent() != 0 || this.getAdditionalCount() != 0
            ? this.getResultingItem()
                  .getPriceBeforeTax()
                  .subtract(this.getPriceBeforeTax())
            : Money.parse(0);
    }

    getUnitOfMeasure() {
        return i18n.t(`products.unit_of_measure.${this.unit_of_measure}`) !== `products.unit_of_measure.${this.unit_of_measure}`
            ? i18n.t(`products.unit_of_measure.${this.unit_of_measure}`)
            : this.unit_of_measure
    }
}

export default OrderItem;
